interface Scripts {
    name: string;
    src: string;
}
export const ScriptStore: Scripts[] = [
    { name: 'confetti', src: '../../../../assets/JS/confetti-animation.js' }
];
